"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_helmet_1 = __importDefault(require("react-helmet"));
var useSportEventSeoMicromarking_1 = __importDefault(require("./useSportEventSeoMicromarking"));
var SportEventSeoMicromarking = function (_a) {
    var sportEventId = _a.sportEventId, getHelmetScript = _a.getHelmetScript;
    var output = useSportEventSeoMicromarking_1.default({
        sportEventId: sportEventId,
    });
    if (!output)
        return null;
    var helmetScript = getHelmetScript(output);
    return react_1.createElement(react_helmet_1.default, { script: helmetScript });
};
exports.default = react_1.memo(SportEventSeoMicromarking);
//# sourceMappingURL=SportEventSeoMicromarking.js.map